/** Start the offline machinery: heartbeat, background sync and the offline PIN cache. */
import { startConnectivity } from './connectivity.js';
import { resolveStaffBridge } from '../printing/bridge.js';
import { flushPrintQueue, queuedPrints } from './print.js';
import { startSync } from './sync.js';

export function startOffline(): () => void {
  const stopConnectivity = startConnectivity();
  const stopSync = startSync();
  // Documents the printers could not take (offline print queue) are tried again.
  const printTimer = setInterval(() => {
    void queuedPrints().then((q) => {
      if (q.length > 0) void flushPrintQueue({ bridge: resolveStaffBridge().bridge });
    });
  }, 10_000);
  return () => {
    clearInterval(printTimer);
    stopSync();
    stopConnectivity();
  };
}

export { OfflineBanner } from './OfflineBanner.js';
export { connectivity, useConnectivity } from './connectivity.js';
export { OfflineRefusal } from './refusal.js';
